import { render, staticRenderFns } from "./GroupChange.vue?vue&type=template&id=1479db5c&scoped=true&"
import script from "./GroupChange.vue?vue&type=script&lang=js&"
export * from "./GroupChange.vue?vue&type=script&lang=js&"
import style0 from "./GroupChange.vue?vue&type=style&index=0&id=1479db5c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1479db5c",
  null
  
)

export default component.exports